import { ClientField, ClientFormInstance } from 'shared/types/appTypes';

/**
 * Check if a client form field has a meaningful value
 */
export const hasValue = (field: ClientField): boolean => {
  if (!('value' in field)) return false;
  const v = field.value;
  if (v == null || v === '' || v === undefined) return false;
  if (field.type === 'appleMusicPlaylist' && Array.isArray(v) && v.length === 0) return false;
  if (field.type === 'multipleChoice') {
    if (Array.isArray(v)) {
      return v.some((item) => String(item || '').trim().length > 0);
    }
    return String(v).trim().length > 0;
  }
  if (field.type === 'address') {
    const address = v as {
      addressLine1?: string;
      addressLine2?: string;
      city?: string;
      state?: string;
      postalCode?: string;
      country?: string;
    };
    return [
      address.addressLine1,
      address.addressLine2,
      address.city,
      address.state,
      address.postalCode,
      address.country,
    ].some((part) => !!String(part || '').trim());
  }
  if (field.type === 'dateRange' || field.type === 'timeRange') {
    const range = v as { start: any; end: any };
    return range.start != null || range.end != null;
  }
  return true;
};

/**
 * Check if a field is answerable by the client (excludes display-only fields like video)
 */
export const isAnswerableField = (field: ClientField): boolean => {
  return field.type !== 'video';
};

/**
 * Get completion status for a client form
 * Returns the number of filled fields and total fields (excluding display-only fields)
 */
export const getFormCompletionStatus = (
  formData: ClientFormInstance | null
): { filledCount: number; totalCount: number } => {
  if (!formData?.fields) {
    return { filledCount: 0, totalCount: 0 };
  }

  const fields = formData.fields.filter(isAnswerableField);
  const filledCount = fields.filter(hasValue).length;

  return {
    filledCount,
    totalCount: fields.length
  };
};
